//@flow
import React from 'react';
import Constants from '../../constants';
import AccessibleButtonWrapper from '../../Icon/components/AccessibleButtonWrapper.react';
import ModalActions from '../../Actions/modal';

function _openPromoEmailCaptureModal() {
  ModalActions.openModal(Constants.PROMO_EMAIL_CAPTURE_MODAL);
}

export default function GetPromoButton() {
  return (
    <div>
      <div className="get-promo-link" onClick={_openPromoEmailCaptureModal}>Get the promo code</div>
      <AccessibleButtonWrapper
        className="get-promo-btn"
        action={_openPromoEmailCaptureModal}
        label="Get promo code"
      >
        Get the promo code
      </AccessibleButtonWrapper>
    </div>
  );
}
